import Vue from 'vue'
import App from './App'
import router from './Router'
import store from './Store'
import BootstrapVue from 'bootstrap-vue'
import './Native'
// import {
//   BModal,
//   VBModal
// } from 'bootstrap-vue'
// import 'jquery'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/js/src/util'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/js/bootstrap.bundle.min'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.min'
import 'bootstrap-vue/dist/bootstrap-vue.common.min'
import 'bootstrap-vue/dist/bootstrap-vue.css'
// import './assets/css/font-awesome.min.css'
// import '@fortawesome/fontawesome-free/css/all.css'
// import '@fortawesome/fontawesome-free/js/all.js'

Vue.use(BootstrapVue)

// Vue.component('b-modal', BModal)
// Vue.directive('b-modal', VBModal)

Vue.config.productionTip = false

Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: {
    App
  }
})